export default __webpack_public_path__ + "static/media/3.cb6cb190.jpg";